import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {LoadingService} from '../loading.service';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";



@Component({
  selector: 'app-wordsontop',
  templateUrl: './wordsontop.component.html',
  styleUrls: ['./wordsontop.component.css']
})
export class WordsontopComponent implements OnInit {
wordsontop:any;
  constructor(private loading:LoadingService) { }

  ngOnInit() {
    this.loading.loading = true;
    console.log(this.loading.loading);
    let db = firebase.database();
 db.ref('wordsontop').once('value').then((snapshot)=>{
      this.wordsontop = snapshot.val().wordsontop;
      console.log(this.wordsontop);
      this.loading.loading = false;
        console.log(this.loading.loading);
    })
  }
  save(wordsontopform:NgForm){
    console.log(wordsontopform.value);
    let db = firebase.database();
    db.ref('wordsontop').set({wordsontop:wordsontopform.value.wordsontop }, (error)=>{
      if(error){
        alert(error);
      }else{alert('text saved successfully')}
    })
  }

}
